import React from "react";
import NumberMath from "../../components/ClassOne/Mathematics"; 
import EnvironmentScience from "../../components/ClassOne/EnvironmentScience";
import English from "../../components/ClassOne/English";
import EnglishMenu from "./EnglishMenu";
import EnvironmentScienceMenu from "./EnvironmentScience";
import MathematicsMenu from "./Mathematics";
import ComputerStudies from "../../components/ClassOne/ComputerStudies";
import ComputerMenu from "./ComputerStudies";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; 
    subMenu?: MenuItem[]; 
}

// Define ClassTwoMenu with the proper type
const ClassOneMenu: MenuItem[] = [
    { 
        url: "/class-one/mathematics", 
        title: "Mathematics", 
        component: NumberMath, 
        subMenu: MathematicsMenu
    },
    { 
        url: "/class-one/english", 
        title: "English", 
        component: English, 
        subMenu: EnglishMenu
    },
    { 
        url: "/class-one/environmental-science", 
        title: "Environmental Science", 
        component: EnvironmentScience, 
        subMenu: EnvironmentScienceMenu
    },
    // { 
    //     url: "/class-one/computer-studies", 
    //     title: "Computer Studies", 
    //     component: ComputerStudies, 
    //     subMenu: ComputerMenu
    // }
];

export default ClassOneMenu;

